export enum ColumnCount {
  four = 3,
  three = 4,
}
